import {Component, inject, Input} from '@angular/core';
import {PlayerProfile} from '../../../../../model/player-profile';
import {TranslatePipe} from '@ngx-translate/core';
import {Tooltip} from 'primeng/tooltip';
import {CdkCopyToClipboard} from '@angular/cdk/clipboard';
import {RestErrorHelper} from '../../../../../../../helper/rest-error-helper';
import {Button} from 'primeng/button';
import {PlayerProfileService} from '../../../../../service/player-profile.service';
import {PlayerSessionService} from '../../../../../service/player-session.service';
import {RegistrationCodePipe} from '../../../../../pipes/registration-code.pipe';

@Component({
  selector: 'app-player-profile-registration-pin',
  imports: [
    TranslatePipe,
    Tooltip,
    CdkCopyToClipboard,
    Button,
    RegistrationCodePipe
  ],
  templateUrl: './player-profile-registration-pin.component.html',
  styleUrl: './player-profile-registration-pin.component.scss'
})
export class PlayerProfileRegistrationPinComponent
{
  public restErrorHelper = inject(RestErrorHelper);
  public playerProfileService = inject(PlayerProfileService);
  public playerSessionService = inject(PlayerSessionService);

  @Input() playerProfile: PlayerProfile;
  isCreating: boolean;
  isDeleting: boolean;

  public createRegistrationCode(): void
  {
    this.isCreating = true;

    this.playerProfileService.generateRegistrationCode().subscribe({
      next: response =>
      {
        console.log('Anmeldecode erstellt', response);
        this.isCreating = false;
        this.playerProfile.registrationPin = response.registrationPin;
        this.playerProfile.registrationPinValidTo = response.registrationPinValidTo;
      },
      error: error =>
      {
        this.isCreating = false;
        this.restErrorHelper.handleErrorService(error);
      }
    });
  }

  public deleteRegistrationCode(): void
  {
    this.isDeleting = true;

    this.playerProfileService.deleteRegistrationCode().subscribe({
      next: response =>
      {
        console.log('Anmeldecode gelöscht', response);
        this.isDeleting = false;
        this.playerProfile.registrationPin = undefined;
        this.playerProfile.registrationPinValidTo = undefined;
      },
      error: error =>
      {
        this.isDeleting = false;
        this.restErrorHelper.handleErrorService(error);
      }
    });
  }
}
